import{baseCheckboxPropDefs as r}from"./_internal/base-checkbox.props.js";export{r as checkboxPropDefs};
//# sourceMappingURL=checkbox.props.js.map
